import { render, staticRenderFns } from "./createCustomRouteInformation.vue?vue&type=template&id=28f75019"
import script from "./createCustomRouteInformation.vue?vue&type=script&lang=js"
export * from "./createCustomRouteInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports